<template>
  <div class="tipsContianer j-pay-tips">
    <i class="closeTipsBtn" v-on:click="close"></i>
    <p class="tips-content">請跳轉前往儲值頁面</p>
    <footer class="tips-footer">
      <a class="skipPayBtn j-skip-pay-btn" v-on:click="pay">跳轉</a>
    </footer>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["pageLink", "pid"],
  methods: {
    close() {
      this.$nextTick(() => {
        this.$emit("closePayTips");
      });
    },
    pay() {
      this.gaStatistics({
        eventName: "exc_store_pay",
        data: {
          pid: this.pid,
          pay_type: "store_page",
        },
      });
      window.open(this.pageLink, "_blank");
      this.close();
    },
    ...mapActions(["gaStatistics"]),
  },
  name: "PayTips",
};
</script>

<style lang="scss">
$imgURL: "../assets/img/";
$yellowColor: #f87e19;
$divide: 10 !default;
$pswWidth: 750;

.tipsContianer {
  position: absolute;
  z-index: 100;
  left: 50%;
  top: 50%;
  width: 477px;
  height: 252px;
  background: white;
  margin-left: (-477px/2);
  margin-top: (-252px/2);
  border: 2px solid $yellowColor;
  border-radius: 8px;
}
.closeTipsBtn {
  position: absolute;
  right: -25px;
  top: -25px;
  width: 57px;
  height: 57px;
  display: block;
  cursor: pointer;
  background: url($imgURL + "x.png");
  background-size: 100% 100%;
}
.tips-content {
  width: 100%;
  margin-top: 43px;
  font-size: 28px;
  text-align: center;
  color: #666;
}
.tips-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 82px;
  background: #8e8e8e;
  border-radius: 0 0 6px 6px;
}
.skipPayBtn {
  width: 177px;
  height: 56px;
  border-radius: 8px;
  color: white;
  font-size: 20px;
  line-height: 56px;
  text-align: center;
  display: block;
  background: $yellowColor;
  margin: (82px - 56px)/2 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/PayTips.vue